import createLucideIcon from '../createLucideIcon';

const ArrowUpLeft = createLucideIcon('ArrowUpLeft', [
  ['line', { x1: '17', x2: '7', y1: '17', y2: '7', key: '1sxhcq' }],
  ['polyline', { points: '7 17 7 7 17 7', key: '1jae2c' }],
]);

export default ArrowUpLeft;
